export const ACTION_TYPE_NOTIFICATION = {
  GET_NOTIFICATION_LIST: 'GET_NOTIFICATION_LIST',
  GET_NOTIFICATION_LIST_SUCCESS: 'GET_NOTIFICATION_LIST_SUCCESS',
  GET_NOTIFICATION_LIST_ERROR: 'GET_CHILD_ALLERGY_ERROR',

  SET_NOTIFICATION_LIST: 'SET_NOTIFICATION_LIST',
  SET_NOTIFICATION_LIST_SUCCESS: 'SET_NOTIFICATION_LIST_SUCCESS',
  SET_NOTIFICATION_LIST_ERROR: 'SET_NOTIFICATION_LIST_ERROR',
}
